import React from 'react';
import './WhatsAppButton.css';
import { FaWhatsapp } from "react-icons/fa";
import { SiZomato } from "react-icons/si";

const WhatsAppButton = () => {   return (
    <div className="floating-buttons">
      {/* WhatsApp */}
      <a
        href="https://wa.me/08827953485"
        className="fab whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      {/* Zomato */}
      <a
        href="https://zomato.onelink.me/xqzv/i0ttqayx"
        className="fab zomato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Zomato"
      >
        <SiZomato />
      </a>
    </div>
  );
};

export default WhatsAppButton;